// @flow

import 'isomorphic-fetch'
import { getApiBaseUrl } from '../utils'
import { basicGet } from '../utils/api'
import { getErrorAction } from '../utils/actions'
import type { Action } from '../types/actions/organizations'
import type { APIError } from '../types'

export const FETCH_ORGANIZATIONS_REQUEST = 'FETCH_ORGANIZATIONS_REQUEST'
export const FETCH_ORGANIZATIONS_SUCCESS = 'FETCH_ORGANIZATIONS_SUCCESS'
export const FETCH_ORGANIZATIONS_FAILURE = 'FETCH_ORGANIZATIONS_FAILURE'

export function fetchOrganizationsRequest(): Action {
  return {
    type: FETCH_ORGANIZATIONS_REQUEST
  }
}

export function fetchOrganizationsSuccess(response: {
  organizations: Array<Object>
}): Action {
  return {
    type: FETCH_ORGANIZATIONS_SUCCESS,
    organizations: response.organizations
  }
}

export function fetchOrganizationsFailure(error: APIError): Action {
  return getErrorAction(FETCH_ORGANIZATIONS_FAILURE, error)
}

export function fetchOrganizations(): Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = getApiBaseUrl()
    return basicGet(
      state,
      dispatch,
      url,
      fetchOrganizationsRequest,
      fetchOrganizationsSuccess,
      fetchOrganizationsFailure
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/organizations.js